var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 2H0v2.003h24V2zm0 3.997H0V8h24V5.997zm0 4.005H0v2.003h24v-2.003zM24 14H0v2.003h24V14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12-.003H0v8.618h12V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M6.607 6.282a1.98 1.98 0 110-3.952c.328-.002.651.08.938.24a2.392 2.392 0 00-1.703-.698A2.437 2.437 0 107.545 6.05c-.289.154-.61.234-.938.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M7.162 2.915l.353.735.795-.18-.36.727.637.51-.795.18.008.81-.638-.51-.63.51v-.81l-.795-.18.638-.51-.353-.727.788.18.352-.735z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/Malaysia.4934b0a61b4c97ca56be5b56d2561be8.svg";
export { ForwardRef as ReactComponent };